import { defineComponent, ref, watch } from "vue";
import TuiButton from "../../common/base/Button.vue.mjs";
import { useI18n } from "../../../locales/index.mjs";
import "../../../services/main.mjs";
import { roomService } from "../../../services/roomService.mjs";
import { TUIInvitationStatus } from "@tencentcloud/tuiroom-engine-js";
import "../../../utils/environment.mjs";
import "mitt";
import "../../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
import renderMsg from "../../common/base/Message/Message.mjs";
import { MESSAGE_DURATION } from "../../../constants/message.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MemberInvite",
  props: {
    userInfo: null
  },
  setup(__props) {
    const props = __props;
    const { t } = useI18n();
    const showReject = ref(false);
    const handleInvite = () => {
      roomService.conferenceInvitationManager.inviteUsers({
        userIdList: [props.userInfo.userId]
      });
      renderMsg({
        type: "success",
        message: t("Invitation sent, waiting for members to join."),
        duration: MESSAGE_DURATION.NORMAL
      });
    };
    watch(props.userInfo, (val) => {
      if (val.status === TUIInvitationStatus.kRejected) {
        showReject.value = true;
        setTimeout(() => {
          showReject.value = false;
        }, 3e3);
      }
    });
    return { __sfc: true, t, showReject, handleInvite, props, TuiButton, TUIInvitationStatus };
  }
});
export {
  _sfc_main as default
};
